import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiagonalLine = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	preserveAspectRatio: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("line", {
		x1: 0,
		y1: 40,
		x2: 40,
		y2: 0,
		strokeWidth: 1,
		stroke: "#808080",
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgDiagonalLine);
export default ForwardRef;
